import type { RouteRecordRaw } from 'vue-router';
import { LazyComponent } from '@/models/LazyComponent';
import '@/features/credito/assets/creditoGlobal.scss';

export const CREDITO_PATH_PREFIX = '/credito';

export const CREDITO_QUALIFICACAO_PATH = '/credito/qualificacao';
export const CREDITO_QUALIFICACAO_INTENCAO_PATH = '/credito/qualificacao/intencao';
export const CREDITO_BLOQUEADO_PATH = '/credito/bloqueado';
/** Tela de autorização (LGPD + ciência do desconto). O path é histórico. */
export const CREDITO_COMO_FUNCIONA_PATH = '/credito/como-funciona';
export const CREDITO_CONSENTIMENTO_PATH = '/credito/consentimento';
export const CREDITO_SIMULACAO_PATH = '/credito/simulacao';
/** Chave PIX, confirmação final e ciência do desconto — depois de ver a oferta, antes da proposta. */
export const CREDITO_RECEBIMENTO_PATH = '/credito/recebimento';
export const CREDITO_SUCESSO_PATH = '/credito/sucesso';

const QualificacaoVinculoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/QualificacaoVinculoView.vue');
const QualificacaoIntencaoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/QualificacaoIntencaoView.vue');
const BloqueadoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/BloqueadoView.vue');
const ComoFuncionaView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/ComoFuncionaView.vue');
const ConsentimentoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/ConsentimentoView.vue');
const SimulacaoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/SimulacaoView.vue');
const RecebimentoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/RecebimentoView.vue');
const SucessoView: LazyComponent = () =>
  import(/* webpackChunkName: "credito" */ '@/features/credito/views/SucessoView.vue');

/**
 * Rotas da jornada de consignado CLT (Fase 1, proativa). Sem `allowAnonymous`: o guard global
 * exige sessão. O kill-switch é aplicado em `resolveCreditoNavigationRedirect`.
 *
 * Sem rota de hub (`/credito`) e sem `/autorizacao` ou `/assinatura`: a entrada é o card no
 * empty-state de `/dividas` e a assinatura acontece na URL da UY3.
 *
 * Sem `/credito/sem-elegibilidade`: quem responde "não" ao #gate simplesmente não avança — decisão
 * de seguir o protótipo, que já tratava essa resposta como copy morta, nunca renderizada.
 */
const routes: RouteRecordRaw[] = [
  {
    path: CREDITO_QUALIFICACAO_PATH,
    name: 'credito-qualificacao',
    component: QualificacaoVinculoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_QUALIFICACAO_INTENCAO_PATH,
    name: 'credito-qualificacao-intencao',
    component: QualificacaoIntencaoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_BLOQUEADO_PATH,
    name: 'credito-bloqueado',
    component: BloqueadoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_COMO_FUNCIONA_PATH,
    name: 'credito-como-funciona',
    component: ComoFuncionaView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_CONSENTIMENTO_PATH,
    name: 'credito-consentimento',
    component: ConsentimentoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_SIMULACAO_PATH,
    name: 'credito-simulacao',
    component: SimulacaoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_RECEBIMENTO_PATH,
    name: 'credito-recebimento',
    component: RecebimentoView,
    meta: { scrollToTop: true },
  },
  {
    path: CREDITO_SUCESSO_PATH,
    name: 'credito-sucesso',
    component: SucessoView,
    meta: { scrollToTop: true },
  },
];

export default routes;
